export const MIN_LENGTH = 6;
export const MAX_LENGTH = 12;
